export default __webpack_public_path__ + "static/media/circled-cross.c355afd0.svg";